import { cn } from '@/lib/utils'
import { RiskLevel } from '@/types'

interface RiskBadgeProps {
  level: RiskLevel
  className?: string
}

export function RiskBadge({ level, className }: RiskBadgeProps) {
  const colorMap: Record<RiskLevel, string> = {
    'acceptable': 'bg-[var(--tint-green-bg)] text-[var(--tint-green-fg)] dark:bg-green-500/20 dark:text-green-400',
    'acceptable-clarify': 'bg-[var(--tint-amber-bg)] text-[var(--tint-amber-fg)] dark:bg-yellow-500/20 dark:text-yellow-400',
    'not-acceptable': 'bg-[var(--tint-red-bg)] text-[var(--tint-red-fg)] dark:bg-red-500/20 dark:text-red-400',
  }

  const labelMap: Record<RiskLevel, string> = {
    'acceptable': 'Acceptable',
    'acceptable-clarify': 'Acceptable Clarify',
    'not-acceptable': 'Not Acceptable',
  }

  return (
    <span className={cn(
      "inline-block px-2.5 py-1 rounded-md text-xs font-medium",
      colorMap[level] || 'bg-gray-500/20 text-gray-400',
      className
    )}>
      {labelMap[level] || level}
    </span>
  )
}
